import Vue from 'vue';
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
    preLoad: 1.5,
    loading: 'preloader.gif',
    attempt: 5
});
